import { ApiResourceBaseClass as s } from "./baseApiCalls.js";
const a = "bulk_review_treated";
class n extends s {
  async submitBulkReviewTreatmentCall(e) {
    const { data: t } = await this.post(a, e);
    return t;
  }
}
export {
  n as ReviewTreatmentAdmin
};
